// @ts-nocheck
// OMIG brand colors
export const lightColors = {
  white: '#fff',
  black: '#000',
  primary: '#B30838',       // crimsonGlory
  light: '#F2F2F2',         // lightGrey
  dark: '#333333',          // veryDarkGrey
  darkGrey: '#606060',      // darkGrey
  success: '#16a34a',
  danger: '#eb445a',
  warning: '#ffc409',
  segmentBg: '#F2F2F2',
  overlay: 'rgba(255, 255, 255, 0.9)',
};

export const darkColors = {
  white: '#000',
  black: '#fff',
  primary: '#B30838',
  light: '#F2F2F2',
  dark: '#f4f5f8',
  darkGrey: '#999999',
  success: '#16a34a',
  danger: '#eb445a',
  warning: '#ffc409',
  segmentBg: '#4b4b4b',
  overlay: 'rgba(0, 0, 0, 0.9)',
};

export type ColorPalette = typeof lightColors;
